import React from 'react';
import type { FeatureFlagApiPayload } from 'app_api/projects/feature_flags/types';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { useTranslation } from 'common/i18n/hooks';
import { useCreateFeatureFlag } from 'iron/apps/feature-flags/src/components/hooks/useCreateFeatureFlag';
import styles from './index.module.styl';
export function FeatureFlagListHeader() {
  const i18n = useTranslation();
  const createFeatureFlag = useCreateFeatureFlag();
  const handleCreateFeatureFlag = React.useCallback(() => {
    const newFeatureFlag: FeatureFlagApiPayload = {
      name: "New Feature Flag",
      key: "new_feature_flag_".concat(Date.now()),
      context: "distinct_id",
      serving_method: "client",
      ruleset: {
        variants: [{
          key: "enabled",
          value: "enabled",
          description: "Feature flag enabled",
          split: 0,
          is_control: false
        }, {
          key: "disabled",
          value: "disabled",
          description: "Feature flag disabled",
          split: 1.0,
          is_control: true
        }],
        rollout: [{
          name: "All Users",
          rollout_percentage: 0,
          cohort_definition: {
            all: true
          }
        }]
      },
      tags: []
    };
    createFeatureFlag(newFeatureFlag);
  }, [createFeatureFlag]);
  return <div className={styles.container} data-sentry-component="FeatureFlagListHeader" data-sentry-source-file="index.tsx">
      <div className={styles.title}>{i18n.t("feature-flags.list.title")}</div>
      <ButtonReact icon='plus' theme={ButtonTheme.Primary} onClick={handleCreateFeatureFlag} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx">
        {i18n.t("feature-flags.list.new")}
      </ButtonReact>
    </div>;
}